<script>
import OrderItem from '@/components/atoms/OrderItem'
export default {
    name: 'CartOrderDetails',
    components: { OrderItem },
    props: {
        model: {
            type: Object,
            default: () => {},
        },
    },
}
</script>

<template lang="pug">
.card.shadow-2(v-if="model")
    .card-header
        h3.my-0 {{$t('order.order')}} {{model.identifier}}
    .card-body
        order-item(
            v-for="(item, index) in model.items"
            :key="`orderedItem-${index}`"
            :model="item"
            :locale="model.locale"
            :currency="model.currency"
            :noBorder="index === 0")
        hr.card-separator
        .d-flex.align-items-center.justify-content-between.mb-3
            span.font-weight-medium {{$t('order.subtotal')}}
            span.font-weight-medium {{ model.price_sum_items | toCurrency(model.locale, model.currency) }}
        .d-flex.align-items-center.justify-content-between.mb-3
            span.font-weight-medium {{$t('order.delivery_fee')}}
            span.font-weight-medium
                template(v-if="model.price_delivery > 0") {{ model.price_delivery | toCurrency(model.locale, model.currency) }}
                template(v-else) {{$t('order.free')}}
        .d-flex.align-items-center.justify-content-between.mb-3(v-if="model.price_coupon_discount")
            span.font-weight-bold {{$t('order.referral_discount')}}
                small ({{model.coupon_code}})
            span.font-weight-bold -{{ model.price_coupon_discount | toCurrency(model.locale, model.currency) }}
        .d-flex.align-items-center.justify-content-between(:class="{'mb-3': model.payment_method}")
            span.font-weight-bold {{$t('order.total')}}
            span.font-weight-bold {{ model.price_sum | toCurrency(model.locale, model.currency) }}
        template(v-if="model.price_sum_firm > 0")
            hr.card-separator
            h4 {{$t('order.payment_details')}}
            .d-flex.align-items-center.justify-content-between.mb-3(v-if="model.selected_expense_rule")
                span.text-sm {{ $t('order.paid_by_expense_rule', {name: model.selected_expense_rule.name}) }}
                span.text-sm {{ model.price_sum_firm | toCurrency(model.locale, model.currency) }}
            .d-flex.align-items-center.justify-content-between(v-if="model.price_sum_user > 0")
                span.text-sm {{$t('order.paid_by', {type: $t(`order.payment_methods.${model.payment_method}`).toLowerCase()})}}
                span.text-sm {{ model.price_sum_user | toCurrency(model.locale, model.currency) }}
        template(v-if="model.cost_code")
            hr.card-separator
            .d-flex.align-items-center.justify-content-between
                span.text-sm {{$t('order.expense_code')}}
                span.text-sm {{ model.cost_code }}
</template>
